
import chevronRightIcon from "../../assets/icons/chevron-right.svg";


export const View = ({ navtitle, navtitlelink, icon = chevronRightIcon }) => {
  return (
    <>
        <div className="settings-navlinks-container">
            <div className="">
              {navtitle}
            </div>
            <img src={chevronRightIcon} alt="chevronright icon" className="chevronright-icon" />
            <div className="checkout-payment-link">
              {navtitlelink}
            </div>  
              
        </div>
    </>
  );
};
